import { FC } from 'react';
import '../BordBadge/BordBadge.scss';

export interface IBordBadgeProps {
  label?: string;
  variant?: 'default' | 'gradient' | 'available' | 'unavailable' | 'secondary';
  size?: 'xs' | 'sm' | 'md' | 'lg';
  Jsx?: JSX.Element;
  customClassName?: string;
}

enum BADGE_VARIANTS {
  default = 'default',
  gradient = 'gradient',
  available = 'available',
  unavailable = 'unavailable',
  secondary = 'secondary'
}

const BordBadge: FC<IBordBadgeProps> = ({ label = 'Label', Jsx, variant = 'default', size, customClassName = '' }) => {
  const renderVariants = {
    [BADGE_VARIANTS.default]: {
      styles: 'defaultStyles',
      component: <div>{Jsx ? Jsx : label}</div>
    },
    [BADGE_VARIANTS.gradient]: {
      styles: 'gradientStyles',
      component: <div className="gradientComponentStyles">{Jsx ? Jsx : label}</div>
    },
    [BADGE_VARIANTS.available]: {
      styles: 'availableStyles',
      component: <div className="availableComponentStyles">{Jsx ? Jsx : label}</div>
    },
    [BADGE_VARIANTS.unavailable]: {
      styles: 'unavailableStyles',
      component: <div className="unavailableComponentStyles">{Jsx ? Jsx : label}</div>
    },
    [BADGE_VARIANTS.secondary]: {
      styles: 'secondaryStyles',
      component: <span>{Jsx ? Jsx : label}</span>
    }
  };
  return (
    <div className={`bordBadge ${customClassName} ${renderVariants[variant]?.styles} ${size ? `${size}` : ''} `}>
      {renderVariants[variant]?.component}
    </div>
  );
};

export default BordBadge;
